export const LANGUAGE_QUERY_PARAM = 'lang';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', labelKey: 'language.en', hreflang: 'en', ogLocale: 'en_US' },
  { code: 'de', labelKey: 'language.de', hreflang: 'de', ogLocale: 'de_DE' },
  { code: 'fr', labelKey: 'language.fr', hreflang: 'fr', ogLocale: 'fr_FR' },
  { code: 'es', labelKey: 'language.es', hreflang: 'es', ogLocale: 'es_ES' },
  { code: 'pt', labelKey: 'language.pt', hreflang: 'pt-BR', ogLocale: 'pt_BR' },
] as const;

export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: SupportedLanguageCode = 'en';

export const LANGUAGE_STORAGE_KEY = 'spotdove.lang';
